<script lang="ts">
  import { addBreadcrumb } from "@sentry/sveltekit";
  import { onMount } from "svelte";

  let online = true;

  onMount(function () {
    online = navigator.onLine;
  });

  function setOnlineStatus() {
    online = navigator.onLine;

    addBreadcrumb({
      category: "network.status",
      data: { online }
    });
  }
</script>

{#if !online}
  <p class="OfflineBanner" role="alert" aria-live="polite">
    You are offline. Information could be out of date.
  </p>

  <style>
    :root {
      --offline-padding: 30px;
    }
  </style>
{/if}

<svelte:window on:online={setOnlineStatus} on:offline={setOnlineStatus} />

<style>
  .OfflineBanner {
    background: #17447d;
    color: white;
    flex: 0 0;
    font-size: 14px;
    line-height: 1;
    margin: 0;
    padding: 8px;
    text-align: center;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.54);
  }
</style>
